import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { normalizeLanguage, type AppLanguage } from './config';

export function withLanguage(path: string, language: AppLanguage): string {
    const [base, hash] = path.split('#');
    const separator = base.includes('?') ? '&' : '?';
    return `${base}${separator}lang=${language}${hash ? `#${hash}` : ''}`;
}

export function useLanguage() {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const language = normalizeLanguage(i18n.language);

    const setLanguage = (next: AppLanguage) => {
        const params = new URLSearchParams(location.search);
        params.set('lang', next);
        navigate({ pathname: location.pathname, search: `?${params.toString()}`, hash: location.hash }, { replace: true, preventScrollReset: true });
    };

    const localizedPath = (path: string) => withLanguage(path, language);

    return { language, setLanguage, localizedPath };
}
